export const SUPPORT_PORTAL_URL =
  process.env.REACT_APP_SUPPORT_PORTAL_URL || 'https://support.prodaff.com/';
